var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{attrs:{"title":"Início do Projeto 🚀"}},[_c('b-card-text',[_vm._v("Seja bem-vindo")]),_c('b-card-text',[_vm._v("Por aqui você conseguirá atualizar grupos e usinas.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }